/* Signe R7 5/8: Add to cart + header-"Added"-feedback skal virke paa ALLE sider.
   Global fallback: opsnapper submits paa kort-formularer mod /cart/add, som ingen
   sektion selv har haandteret (defaultPrevented-guard), koerer add.js og udloeser
   cd:added-to-cart (header-popover) + opdaterer kurv-badges. */
(function () {
  function updateBadges() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cd-cart__badge, .cd-mcart__badge').forEach(function (el) { el.textContent = cart.item_count; });
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form && form.getAttribute)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return; /* sektionens egen JS har taget den */
    e.preventDefault();
    var idEl = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (!idEl || !idEl.value || (btn && btn.classList.contains('is-loading'))) return;
    if (btn) btn.classList.add('is-loading');
    /* Video-rettelser 13/8: popover MED DET SAMME (optimistisk) + gront HAK paa
       knappen (ikke bare gron farve) — samme feedback som resten af sitet */
    var card = form.closest('.cd-hcard, .cd-ccard, .cd-look__item, .cd-rev__strip, article') || form.parentElement; /* 14/8: 'div' ramte knap-raekken uden billede */
    var img = card ? card.querySelector('img') : null;
    document.dispatchEvent(new CustomEvent('cd:added-to-cart', { detail: { image: (img && img.currentSrc) || '' } }));
    if (btn) {
      var orig = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = '<svg viewBox="0 0 14 11" fill="none" aria-hidden="true" style="width:14px;height:11px;display:block;margin:0 auto"><path d="M1 5.5L5 9.5L13 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = orig; }, 2000);
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        updateBadges();
      }).catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1600); }
      });
  });
})();
